import { render, staticRenderFns } from "./AssetManagementMenu.vue?vue&type=template&id=37d87d66&scoped=true&"
import script from "./AssetManagementMenu.vue?vue&type=script&lang=js&"
export * from "./AssetManagementMenu.vue?vue&type=script&lang=js&"
import style0 from "./AssetManagementMenu.vue?vue&type=style&index=0&id=37d87d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d87d66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d87d66')) {
      api.createRecord('37d87d66', component.options)
    } else {
      api.reload('37d87d66', component.options)
    }
    module.hot.accept("./AssetManagementMenu.vue?vue&type=template&id=37d87d66&scoped=true&", function () {
      api.rerender('37d87d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Layout/Extra/AssetManagementMenu.vue"
export default component.exports